import { render, staticRenderFns } from "./userlist.vue?vue&type=template&id=fd227fc8"
import script from "./userlist.vue?vue&type=script&lang=js"
export * from "./userlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports